/** Small shared building blocks for the REST DTOs. */
import { z } from 'zod';
/** uuidv7 ids from Postgres, as strings. */
export const Uuid = z.uuid();
/** In-game phone number, never a real Nigerian format (51 P8), e.g. `EKW-482-177`. */
export const PHONE_NUMBER_RE = /^[A-Z]{3}-\d{3}-\d{3}$/;
export const PhoneNumber = z.string().regex(PHONE_NUMBER_RE);
/** A recipient given as a phone number or a character id. */
export const Recipient = z.union([PhoneNumber, Uuid]);
